module.exports = __webpack_public_path__ + "img/traveller-stopped.cf812bdc.svg";